export enum BulkOperationTypeEnum {
    statusChange,
    assignment,
    removal,
    export,
    doNotContact
}
